import { render, staticRenderFns } from "./CenterViewSamplePreview_Ap.vue?vue&type=template&id=97f8a6bc&scoped=true"
import script from "./CenterViewSamplePreview_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewSamplePreview_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewSamplePreview_Ap.vue?vue&type=style&index=0&id=97f8a6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f8a6bc",
  null
  
)

export default component.exports